let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fAUr9")).then(() => parcelRequire('7EJ9w'));